<script>
  import { hextorgb } from '$lib/utils/colors.js'

  /** @type {{ primary?: string, secondary?: string, theme?: App.theme, children: Svelte.Snippet }} */
  let { primary, secondary, theme = 'reset', children } = $props()

  const maybeColor = (hex) => (hex ? hextorgb(hex).join(', ') : null)

  let primaryColor = $derived(maybeColor(primary))
  let secondaryColor = $derived(maybeColor(secondary))
</script>

<div
  class="config theme-{theme}"
  style:--rgb-primary={primaryColor}
  style:--rgb-secondary={secondaryColor}>
  {@render children()}
</div>

<style>
  .config {
    display: contents;
  }
</style>
